import React, { useContext, useEffect, useState } from 'react'
import { SearchContext } from '../../lib/context/search-context'
import classes from '../pages/destinations/destinations.module.scss'
import {
  calculateMarkup,
  formatAmountForDisplay,
} from '../../utils/stripe-helpers'
import WTDatePicker from './date-picker'
import moment from 'moment/moment'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faMinus, faPlus } from '@fortawesome/pro-light-svg-icons'
import GuestsPopup from '../popups/guests'
import Button from '../button'
import KeysSvg from '../svg/Keys.svg'
import Link from 'next/link'
import SingleGuestsPopup from '../popups/single-guests'
import config from '../../config'

interface Props {
  price: string
  withRooms?: boolean
  onSearch?: () => void
  buttonLabel: string
  pricePer?: string
  hideCalendar?: boolean

}
const TripDates = ({
  price,
  withRooms,
  onSearch,
  buttonLabel,
  pricePer,
  hideCalendar,
}: Props) => {
  const { searchParams, setSearchParameters } = useContext(SearchContext)
  const [numGuests, setNumGuests] = useState(2)
  const [numRooms, setNumRooms] = useState(searchParams.guests.length)
  const [guestsPopup, setGuestsPopup] = useState(false)

  const updateSingleGuests = (guests) => {
    setNumGuests(guests)
    setSearchParameters(
      {
        ...searchParams,
        guests: [
          {
            paxes: Array.from(Array(guests).keys()).map((key) => {
              return { age: 30 }
            }),
          },
        ],
      },
      0,
      config.cookieOptions
    )
  }

  useEffect(() => {
    if (withRooms) {
      let tmpGuests = 0
      for (const guests of searchParams.guests) {
        tmpGuests += guests.paxes.length
      }
      setNumGuests(tmpGuests)
    }
  }, [searchParams])

  const updateGuests = (value) => {
    let newGuests = 0
    setNumRooms(value.length)
    value.forEach((guests, i) => {
      newGuests += guests.paxes.length
    })
    setNumGuests(newGuests)
    setSearchParameters(
      {
        ...searchParams,
        guests: value,
      },
      0,
      config.cookieOptions
    )
  }

  const handleDateChange = (dates) => {
    setSearchParameters(
      {
        ...searchParams,
        checkinDate: dates.startDate.format('YYYY-MM-DD'),
        checkoutDate: dates.endDate.format('YYYY-MM-DD'),
      },
      0,
      config.cookieOptions
    )
  }

  const triggerSearch = () => {
    if (onSearch) {
      onSearch()
    }
  }
  return (
    <div className={`bookingHover ${classes.booking}`}>
      <div className={classes.bookingHeader}>
        {moment(searchParams.checkinDate).format('YYYY-MM-DD') !==
          moment().add(1, 'day').format('YYYY-MM-DD') && (
          <>
            {price !== '' && (
              <>
                <div className={classes.label}>From</div>
                <span className={classes.price}>
                  {price}
                  {pricePer && <span> / {pricePer}</span>}
                </span>
              </>
            )}
            {price === '' && (
              <>
                <div className={classes.label}>Please select other dates</div>
                <span className={classes.price}>Not Available</span>
              </>
            )}
          </>
        )}
        {moment(searchParams.checkinDate).format('YYYY-MM-DD') ===
          moment().add(1, 'day').format('YYYY-MM-DD') && (
          <>
            <div className={classes.label}>Please</div>
            <span className={classes.price}>Select a date</span>
          </>
        )}
      </div>
      <div className={classes.bookingInner}>
        {!hideCalendar && (
          <>
            <span className={classes.label}>Preferred Trip Dates</span>
            <div className={classes.bookingInput}>
              <WTDatePicker
                hideLabels
                onChange={(dates) => {
                  handleDateChange(dates)
                }}
                defaultStart={
                  searchParams.checkinDate !== null &&
                  moment(searchParams.checkinDate).format('YYYY-MM-DD') !==
                    moment().add(1, 'day').format('YYYY-MM-DD')
                    ? moment(searchParams.checkinDate)
                    : ''
                }
                defaultEnd={
                  searchParams.checkoutDate !== null &&
                  moment(searchParams.checkoutDate).format('YYYY-MM-DD') !==
                    moment().add(2, 'days').format('YYYY-MM-DD')
                    ? moment(searchParams.checkoutDate)
                    : ''
                }
                showIcon={true}
              />
            </div>
            <span className={classes.label}>
              Guests {withRooms && <>&amp; Rooms</>}
            </span>
            <div className={`${classes.bookingInput} ${classes.guestInput}`}>
              {withRooms && (
                <>
                  <span>
                    {numGuests > 0 ? numGuests : 'Add'} Guests, {numRooms} Room
                    {numRooms > 1 && 's'}
                  </span>
                  <div
                    className={classes.icon}
                    onClick={() => {
                      setGuestsPopup(true)
                    }}
                  >
                    <FontAwesomeIcon icon={faPlus} />
                    <FontAwesomeIcon icon={faMinus} />
                  </div>
                  {guestsPopup && (
                    <GuestsPopup
                      popupState={setGuestsPopup}
                      guests={searchParams.guests}
                      handleChange={updateGuests}
                      top={0}
                    />
                  )}
                </>
              )}
              {!withRooms && (
                <>
                  <span>
                    {numGuests} Guest{numGuests > 1 ? 's' : ''}
                  </span>
                  <div
                    className={classes.icon}
                    onClick={() => {
                      setGuestsPopup(true)
                    }}
                  >
                    <FontAwesomeIcon icon={faPlus} />
                    <FontAwesomeIcon icon={faMinus} />
                  </div>
                  {guestsPopup && (
                    <SingleGuestsPopup
                      popupState={(guests) => {
                        setGuestsPopup(false)
                      }}
                      guests={numGuests}
                      handleChange={updateSingleGuests}
                    />
                  )}
                </>
              )}
            </div>
          </>
        )}
        <Button width={'100%'} onClick={triggerSearch} id={`select-dates`} className="cta-event-trigger">
          Select {buttonLabel} &amp; Book
        </Button>
        <div className={classes.footer}>
          <div className={classes.keys}>
            <KeysSvg />
          </div>
          <Link href="/contact-us">Booking Assistance</Link>
        </div>
      </div>
    </div>
  )
}
export default TripDates
